import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMortgageLoanById, getAllAdmins } from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { FaEdit } from 'react-icons/fa';
import { Row, Col, Button } from "react-bootstrap";
import PdfDownloader from "../../../common/PdfDownloader";


const EditMortgageViewModal = ({ isOpen, onClose, loanId }) => {
  const { adminId, adminName, adminRole } = useContext(AuthContext);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    form_id: "",
    created_id: "",
    created_by: "",
    assigned_to: "",
    status: "",
    rejected_reason: "",
    name: "",
    dob: "",
    age: "",
    mobile: "",
    email: "",
    father_name: "",
    mother_name: "",
    marital_status: " ",
    spouse_name: "",
    residence_type: "",
    address: "",
    landmark: "",
    state: "",
    city: "",
    pincode: "",
    present_address_adhaar: "",
    present_address: "",
    present_state: "",
    present_city: "",
    present_pincode: "",
    present_landmark: "",
    required_loan_amount: "",
    existing_emi_amount: "",
    are_you: "",
    company_name: "",
    others_company: "",
    net_salary: "",
    is_pf_deducted: "",
    total_experience: "",
    company_type: "",
    type_your_designation: "",
    office_address: "",
    office_landmark: "",
    office_state: "",
    office_city: " ",
    office_pincode: "",
    register_company: "",
    turnover: "",
    business_type: "",
    description: "",
    business_place: "",
    businessStart_year: "",
    gst_registered: "",
    gst_registerd_year: "",
    msme_registered: "",
    degree: "",
    mbbs_completed_year: "",
    degree_others: "",
    work_type: "",
    service_experience: "",
    clinic_name: "",
    clinic_address: "",
    clinic_state: "",
    clinic_city: "",
    clinic_pincode: "",
    hospital_name: "",
    hospital_address: "",
    hospital_state: "",
    hospital_city: "",
    hospital_pincode: "",
    working_country: "",
    net_salary_indian_rupees: "",
    present_india: "",
    add_reference: "",
    reference_name: "",
    reference_mobile: "",
    reference_address: "",
    reference_location: "",
    bank_name: "",
  });

  const fetchAgents = useCallback(async () => {
    try {
      const response = await getAllAdmins();
      const filteredAgents = response.filter((admin) => admin.role === "employee");
      setAgents(filteredAgents);
    } catch (error) {
      console.error("Error fetching agents:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchLoanData = useCallback(async () => {
    if (loanId && isOpen) {
      try {
        const loan = await getMortgageLoanById(loanId);
        setFormData({
          form_id: loan.form_id || "",
          created_id: loan.created_id || "",
          created_by: loan.created_by || "",
          assigned_to: loan.assigned_to || "",
          status: loan.status || "",
          rejected_reason: loan.rejected_reason || "",
          name: loan.name || "",
          dob: loan.dob || "",
          age: loan.age?.toString() || "",
          mobile: loan.mobile || "",
          email: loan.email || "",
          mother_name: loan.mother_name || "",
          father_name: loan.father_name || "",
          marital_status: loan.marital_status || "",
          spouse_name: loan.spouse_name || "",
          residence_type: loan.residence_type || "",
          address: loan.address || "",
          landmark: loan.landmark || "",
          state: loan.state || "",
          city: loan.city || "",
          pincode: loan.pincode || "",
          present_address_adhaar: loan.present_address_adhaar || "",
          present_address: loan.present_address || "",
          present_state: loan.present_state || "",
          present_city: loan.present_city || "",
          present_pincode: loan.present_pincode || "",
          present_landmark: loan.present_landmark || "",
          required_loan_amount: loan.required_loan_amount?.toString() || "",
          existing_emi_amount: loan.existing_emi_amount?.toString() || "",
          are_you: loan.are_you || "",
          company_name: loan.company_name || "",
          others_company: loan.others_company || "",
          net_salary: loan.net_salary?.toString() || "",
          is_pf_deducted: loan.is_pf_deducted || "",
          total_experience: loan.total_experience?.toString() || "",
          company_type: loan.company_type || "",
          type_your_designation: loan.type_your_designation || "",
          office_address: loan.office_address || "",
          office_landmark: loan.office_landmark || "",
          office_state: loan.office_state || "",
          office_city: loan.office_city || "",
          office_pincode: loan.office_pincode || "",
          register_company: loan.register_company || "",
          turnover: loan.turnover?.toString() || "",
          business_type: loan.business_type || "",
          description: loan.description || "",
          business_place: loan.business_place || "",
          businessStart_year: loan.businessStart_year?.toString() || "",
          gst_registered: loan.gst_registered || "",
          gst_registerd_year: loan.gst_registerd_year || "",
          msme_registered: loan.msme_registered || "",
          filling_itr: loan.filling_itr || "",
          degree: loan.degree || "",
          service_experience: loan.service_experience?.toString() || "",
          mbbs_completed_year: loan.mbbs_completed_year?.toString() || "",
          degree_others: loan.degree_others || "",
          work_type: loan.work_type || "",
          clinic_name: loan.clinic_name || "",
          clinic_address: loan.clinic_address || "",
          clinic_state: loan.clinic_state || "",
          clinic_city: loan.clinic_city || "",
          clinic_pincode: loan.clinic_pincode || "",
          hospital_name: loan.hospital_name || "",
          hospital_address: loan.hospital_address || "",
          hospital_state: loan.hospital_state || "",
          hospital_city: loan.hospital_city || "",
          hospital_pincode: loan.hospital_pincode || "",
          working_country: loan.working_country || "",
          net_salary_indian_rupees: loan.net_salary_indian_rupees?.toString() || "",
          present_india: loan.present_india || "",
          add_reference: loan.add_reference || "",
          reference_name: loan.reference_name || "",
          reference_mobile: loan.reference_mobile || "",
          reference_address: loan.reference_address || "",
          reference_location: loan.reference_location || "",
          bank_name: loan.bank_name || "",
        });
      } catch (error) {
        console.error("Error fetching mortgage loan data:", error);
      }
    }
  }, [loanId, adminId, adminName]);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  useEffect(() => {
    fetchLoanData();
  }, [fetchLoanData]);

  const filteredPdfFormData = [
    {
      title: "Personal Details",
      data: {
        "Loan ID": formData.form_id,
        "Agent ID": formData.created_id,
        "Agent By": formData.created_by,
        "Assign to": formData.assigned_to,
        "Lead Status": formData.status,
        ...(formData.status === "Rejected" && {
          "Rejected Reason": formData.rejected_reason,
        }),
        "Name": formData.name,
        "Date of Birth": formData.dob,
        "Age": formData.age,
        "Mobile": formData.mobile,
        "Email": formData.email,
        "Mother Name": formData.mother_name,
        "Father Name": formData.father_name,
        "Marital Status": formData.marital_status,
        ...(formData.marital_status === "Married" && {
          "Spouse Name": formData.spouse_name,
        }),
        "Residence Type": formData.residence_type,
        "Present Staying Address": formData.address,
        "Landmark": formData.landmark,
        "State": formData.state,
        "City": formData.city,
        "Pincode": formData.pincode,
        "Is Present Address as per Aadhaar": formData.present_address_adhaar,
        ...(formData.present_address_adhaar === "No" && {
          "Present Aadhaar Address": formData.present_address,
          "State(Aadhaar)": formData.present_state,
          "City(Aadhaar)": formData.present_city,
          "Pincode(Aadhaar)": formData.present_pincode,
          "Landmark(Aadhaar)": formData.present_landmark,
        }),
      },
    },
    {
      title: "Income Details",
      data: {
        "Required Loan Amount": formData.required_loan_amount,
        "Existing EMI": formData.existing_emi_amount,
        "Are You": formData.are_you,
        // ...(formData.are_you === "Salaried" || formData.are_you === "Nri" ? {
        //   "Working Company Name": formData.company_name,
        // } : {}),
        ...(formData.are_you === "Salaried" || formData.are_you === "Nri" ? {
          "Working Company Name": formData.others_company,
        } : {}),
        "Bank Name": formData.bank_name,
        ...(formData.are_you === "Salaried" || formData.are_you === "Doctor" ? {
          "Net Salary": formData.net_salary,
          "Is PF Deducted": formData.is_pf_deducted,
          "Total Experience": formData.total_experience,
        } : {}),
        ...(formData.are_you === "Salaried" ? {
          "Company Type": formData.company_type,
          "Type Your Designation": formData.type_your_designation,
          "Office Address": formData.office_address,
          "Office Landmark": formData.office_landmark,
          "Office State": formData.office_state,
          "Office City": formData.office_city,
          "Office Pincode": formData.office_pincode,
        } : {}),
        ...(formData.are_you === "SelfEmployed" ? {
          "Company Registered As": formData.register_company,
          "Annual Turnover": formData.turnover,
          "Nature of Business": formData.business_type,
          ...(formData.business_type === "others" ? {
            "Business Description": formData.description,
          } : {}),
          "Business Place": formData.business_place,
          ...(formData.business_place === "Own" ? {
            "Business Start Year": formData.businessStart_year,
            "GST Registered": formData.gst_registered,
            ...(formData.gst_registered === "Yes" ? {
              "GST Registered Year": formData.gst_registerd_year,
            } : {}),
            "MSME Registered": formData.msme_registered,
            "Are You Filing ITR": formData.filling_itr,
          } : {}),
        } : {}),
        ...(formData.are_you === "Doctor" ? {
          "Degree": formData.degree,
          ...(formData.degree === "MBBS" ? {
            "MBBS Completed Year": formData.mbbs_completed_year,
          } : {}),
          ...(formData.degree === "Others" ? {
            "Degree Others": formData.degree_others,
          } : {}),
          "Work Type": formData.work_type,
          ...(formData.work_type === "Own Clinic" ? {
            "Service Experience": formData.service_experience,
            "Clinic Name": formData.clinic_name,
            "Clinic Address": formData.clinic_address,
            "Clinic State": formData.clinic_state,
            "Clinic City": formData.clinic_city,
            "Clinic Pincode": formData.clinic_pincode,
          } : {}),
          ...(formData.work_type === "Salaried" ? {
            "Hospital Name": formData.hospital_name,
            "Hospital Address": formData.hospital_address,
            "Hospital State": formData.hospital_state,
            "Hospital City": formData.hospital_city,
            "Hospital Pincode": formData.hospital_pincode,
          } : {}),
        } : {}),
        ...(formData.are_you === "Nri" ? {
          "Working Country": formData.working_country,
          "Net Salary in Indian Rupees": formData.net_salary_indian_rupees,
          "Are You Present in India": formData.present_india,
        } : {}),
      },
    },
    {
      title: "Reference Details",
      data: (formData.add_reference === "Relative" || formData.add_reference === "Colleague") ? {
        "Add Reference": formData.add_reference,
        "Name": formData.reference_name,
        "Mobile": formData.reference_mobile,
        "Address": formData.reference_address,
        "Location": formData.reference_location,
      } : {},
    },
  ];

  const handleEditClick = () => {
    navigate(`/edit-mortgage-loan/${loanId}`);
  };

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay-edit')) {
      onClose();
    }
  };

  const formattedDob = formData.dob
    ? (() => {
        const d = new Date(formData.dob);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      })()
    : "";

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-edit" onClick={handleOverlayClick}>
      <div className="modal-content-edit">
      <h3 className="edit-title">
        <span className="product-title-text">Mortgage Loan</span>
        <span className="action-icon">
          <FaEdit
            className="edit-loan"
            style={{ cursor: "pointer" }}
            onClick={handleEditClick}
          />
          <PdfDownloader formData={filteredPdfFormData} loanId={loanId} />
        </span>
      </h3>
        <div className="form-content-section">
          <div className="step-sections-personal-details-sections">
            <h4>Personal Details</h4>
             <div className="form-row-step">
              <strong>Loan ID:</strong>
              <div className="value">{formData.form_id}</div>
            </div>
            {adminRole !== "customer"&&(
              <>
                <div className="form-row-step">
                  <strong>Employee ID:</strong>
                  <div className="value">{formData.created_id}</div>
                </div>
                <div className="form-row-step">
                  <strong>Employee By:</strong>
                  <div className="value">{formData.created_by}</div>
                </div>
              </>
            )}
            {(adminRole === "admin")&&(
              <div className="form-row-step">
                <strong>Assign to:</strong>
                <div className="value">{formData.assigned_to}</div>
              </div>
            )}
            <div className="form-row-step">
              <strong>Lead Status:</strong>
              <div className="value">{formData.status}</div>
            </div>
            {formData.status === "Rejected" && (
              <div className="form-row-step">
                <strong>Rejected reason:</strong>
                <div className="value">{formData.rejected_reason}</div>
              </div>
            )}
            <div className="form-row-step">
              <strong>Name:</strong>
              <div className="value">{formData.name}</div>
            </div>
            <div className="form-row-step">
              <strong>Date of Birth:</strong>
              <div className="value">{formattedDob}</div>
            </div>
            <div className="form-row-step">
              <strong>Age:</strong>
              <div className="value">{formData.age}</div>
            </div>
            <div className="form-row-step">
              <strong>Mobile:</strong>
              <div className="value">{formData.mobile}</div>
            </div>
            <div className="form-row-step">
              <strong>Email:</strong>
              <div className="value">{formData.email}</div>
            </div>
            <div className="form-row-step">
              <strong>Mother Name:</strong>
              <div className="value">{formData.mother_name}</div>
            </div>
            <div className="form-row-step">
              <strong>Father Name:</strong>
              <div className="value">{formData.father_name}</div>
            </div>
            <div className="form-row-step">
              <strong>Marital Status:</strong>
              <div className="value">{formData.marital_status}</div>
            </div>
            {formData.marital_status === "Married" && (
              <div className="form-row-step">
                <strong>Spouse Name:</strong>
                <div className="value">{formData.spouse_name}</div>
              </div>
            )}
            <div className="form-row-step">
              <strong>Residence Type:</strong>
              <div className="value">{formData.residence_type}</div>
            </div>
            <div className="form-row-step">
              <strong>Present Staying Address:</strong>
              <div className="value">{formData.address}</div>
            </div>
            <div className="form-row-step">
              <strong>Landmark:</strong>
              <div className="value">{formData.landmark}</div>
            </div>
            <div className="form-row-step">
              <strong>State:</strong>
              <div className="value">{formData.state}</div>
            </div>
            <div className="form-row-step">
              <strong>City:</strong>
              <div className="value">{formData.city}</div>
            </div>
            <div className="form-row-step">
              <strong>Pincode:</strong>
              <div className="value">{formData.pincode}</div>
            </div>
            <div className="form-row-step">
              <strong>Is Present Address as per Aadhaar:</strong>
              <div className="value">{formData.present_address_adhaar}</div>
            </div>
            {formData.present_address_adhaar === "No" && (
              <>
                <div className="form-row-step">
                  <strong>Present Aadhaar Address:</strong>
                  <div className="value">{formData.present_address}</div>
                </div>
                <div className="form-row-step">
                  <strong>State:</strong>
                  <div className="value">{formData.present_state}</div>
                </div>
                <div className="form-row-step">
                  <strong>City:</strong>
                  <div className="value">{formData.present_city}</div>
                </div>
                <div className="form-row-step">
                  <strong>Pincode:</strong>
                  <div className="value">{formData.present_pincode}</div>
                </div>
                <div className="form-row-step">
                  <strong>Landmark:</strong>
                  <div className="value">{formData.present_landmark}</div>
                </div>
              </>
            )}

            <h4>Income Details</h4>
            <div className="form-row-step">
              <strong>Required Loan Amount:</strong>
              <div className="value">{formData.required_loan_amount}</div>
            </div>
            <div className="form-row-step">
              <strong>Existing EMI:</strong>
              <div className="value">{formData.existing_emi_amount}</div>
            </div>
            <div className="form-row-step">
              <strong>Are You:</strong>
              <div className="value">{formData.are_you}</div>
            </div>
            {/* {(formData.are_you === "Salaried" ||
              formData.are_you === "Nri") && (
              <div className="form-row-step">
                <strong>Working Company Name:</strong>
                <div className="value">{formData.company_name}</div>
              </div>
            )} */}
            {(formData.are_you === "Salaried" ||
              formData.are_you === "Nri") && (
              <div className="form-row-step">
                <strong>Working Company Name:</strong>
                <div className="value">{formData.others_company}</div>
              </div>
            )}
            {adminRole !== "customer"&&(
              <div className="form-row-step">
                <strong>Bank Name:</strong>
                <div className="value">{formData.bank_name}</div>
              </div>
            )}
            {(formData.are_you === "Salaried" ||
              formData.are_you === "Doctor") && (
              <>
                <div className="form-row-step">
                  <strong>Net Salary:</strong>
                  <div className="value">{formData.net_salary}</div>
                </div>
                <div className="form-row-step">
                  <strong>Is PF Deducted:</strong>
                  <div className="value">{formData.is_pf_deducted}</div>
                </div>
                <div className="form-row-step">
                  <strong>Total Experience:</strong>
                  <div className="value">{formData.total_experience}</div>
                </div>
              </>
            )}
            {formData.are_you === "Salaried" && (
              <>
                <div className="form-row-step">
                  <strong>Company Type:</strong>
                  <div className="value">{formData.company_type}</div>
                </div>
                <div className="form-row-step">
                  <strong>Type Your Designation:</strong>
                  <div className="value">{formData.type_your_designation}</div>
                </div>
                <div className="form-row-step">
                  <strong>Office Address:</strong>
                  <div className="value">{formData.office_address}</div>
                </div>
                <div className="form-row-step">
                  <strong>Office Landmark:</strong>
                  <div className="value">{formData.office_landmark}</div>
                </div>
                <div className="form-row-step">
                  <strong>Office State:</strong>
                  <div className="value">{formData.office_state}</div>
                </div>
                <div className="form-row-step">
                  <strong>Office City:</strong>
                  <div className="value">{formData.office_city}</div>
                </div>
                <div className="form-row-step">
                  <strong>Office Pincode:</strong>
                  <div className="value">{formData.office_pincode}</div>
                </div>
              </>
            )}
            {formData.are_you === "SelfEmployed" && (
              <>
                <div className="form-row-step">
                  <strong>Your Company Registered As:</strong>
                  <div className="value">{formData.register_company}</div>
                </div>
                <div className="form-row-step">
                  <strong>Annual Turnover:</strong>
                  <div className="value">{formData.turnover}</div>
                </div>
                <div className="form-row-step">
                  <strong>Nature of Business:</strong>
                  <div className="value">{formData.business_type}</div>
                </div>
                {formData.business_type === "others" && (
                  <div className="form-row-step">
                    <strong>Business Description:</strong>
                    <div className="value">{formData.description}</div>
                  </div>
                )}
                <div className="form-row-step">
                  <strong>Business Place:</strong>
                  <div className="value">{formData.business_place}</div>
                </div>
                {formData.business_place === "Own" && (
                  <>
                    <div className="form-row-step">
                      <strong>Business Start Year:</strong>
                      <div className="value">{formData.businessStart_year}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>GST Registered:</strong>
                      <div className="value">{formData.gst_registered}</div>
                    </div>
                    {formData.gst_registered === "Yes" && (
                      <div className="form-row-step">
                        <strong>GST Registered Year:</strong>
                        <div className="value">
                          {formData.gst_registerd_year}
                        </div>
                      </div>
                    )}
                    <div className="form-row-step">
                      <strong>MSME Registered:</strong>
                      <div className="value">{formData.msme_registered}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Are You Filing ITR:</strong>
                      <div className="value">{formData.filling_itr}</div>
                    </div>
                  </>
                )}
              </>
            )}
            {formData.are_you === "Doctor" && (
              <>
                <div className="form-row-step">
                  <strong>Degree:</strong>
                  <div className="value">{formData.degree}</div>
                </div>
                {formData.degree === "MBBS" && (
                  <>
                    <div className="form-row-step">
                      <strong>MBBS Completed Year:</strong>
                      <div className="value">
                        {formData.mbbs_completed_year}
                      </div>
                    </div>
                  </>
                )}
                {formData.degree === "Others" && (
                  <div className="form-row-step">
                    <strong>Degree Others:</strong>
                    <div className="value">{formData.degree_others}</div>
                  </div>
                )}
                <div className="form-row-step">
                  <strong>Work Type:</strong>
                  <div className="value">{formData.work_type}</div>
                </div>
                {formData.work_type === "Own Clinic" && (
                  <>
                    <div className="form-row-step">
                      <strong>Service Experience:</strong>
                      <div className="value">{formData.service_experience}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Clinic Name:</strong>
                      <div className="value">{formData.clinic_name}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Clinic Address:</strong>
                      <div className="value">{formData.clinic_address}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Clinic State:</strong>
                      <div className="value">{formData.clinic_state}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Clinic City:</strong>
                      <div className="value">{formData.clinic_city}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Clinic Pincode:</strong>
                      <div className="value">{formData.clinic_pincode}</div>
                    </div>
                  </>
                )}
                {formData.work_type === "Salaried" && (
                  <>
                    <div className="form-row-step">
                      <strong>Hospital Name:</strong>
                      <div className="value">{formData.hospital_name}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Hospital Address:</strong>
                      <div className="value">{formData.hospital_address}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Hospital State:</strong>
                      <div className="value">{formData.hospital_state}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Hospital City:</strong>
                      <div className="value">{formData.hospital_city}</div>
                    </div>
                    <div className="form-row-step">
                      <strong>Hospital Pincode:</strong>
                      <div className="value">{formData.hospital_pincode}</div>
                    </div>
                  </>
                )}
              </>
            )}
            {formData.are_you === "Nri" && (
              <>
                <div className="form-row-step">
                  <strong>Working Country:</strong>
                  <div className="value">{formData.working_country}</div>
                </div>
                <div className="form-row-step">
                  <strong>Net Salary in Indian Rupees:</strong>
                  <div className="value">
                    {formData.net_salary_indian_rupees}
                  </div>
                </div>
                <div className="form-row-step">
                  <strong>Are You Present in India:</strong>
                  <div className="value">{formData.present_india}</div>
                </div>
              </>
            )}

            {(formData.add_reference === "Relative" ||
              formData.add_reference === "Colleague") && (
              <>
                <h4>Reference Details</h4>
                <div className="form-row-step">
                  <strong>Add Reference:</strong>
                  <div className="value">{formData.add_reference}</div>
                </div>

                <div className="form-row-step">
                  <strong>Name:</strong>
                  <div className="value">{formData.reference_name}</div>
                </div>

                <div className="form-row-step">
                  <strong>Mobile:</strong>
                  <div className="value">{formData.reference_mobile}</div>
                </div>

                <div className="form-row-step">
                  <strong>Address:</strong>
                  <div className="value">{formData.reference_address}</div>
                </div>

                <div className="form-row-step">
                  <strong>Location:</strong>
                  <div className="value">{formData.reference_location}</div>
                </div>
              </>
            )}
          </div>
          <div className="button-sections">
            <Row>
              <Col className="text-end">
                <Button
                  className="custom-back-button"
                  type="button"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMortgageViewModal;
